import { Alert } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import { ERROR_DISPLAY_TYPES } from '../constants'
import { useAppSelector } from '../store/hooks'
import { selectServiceErrorState } from '../store/slices/handledErrorSlice'

export default function PageErrorAlert() {
  const serviceError = useAppSelector(selectServiceErrorState)

  if (
    serviceError &&
    serviceError.title &&
    serviceError.type === ERROR_DISPLAY_TYPES.IN_PAGE
  ) {
    return (
      <Alert type="error" data-testid="error-alert">
        <Message id={serviceError.title} />
      </Alert>
    )
  }

  return null
}
